import { render, staticRenderFns } from "./success2.vue?vue&type=template&id=04a7d2b5&"
import script from "./success2.vue?vue&type=script&lang=js&"
export * from "./success2.vue?vue&type=script&lang=js&"
import style0 from "./success2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports